import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log('👥 Follow Toggle Controller connected')
  }

  // Handle form submission and prevent dropdown from interfering
  submit(event) {
    // Don't prevent default - let Turbo handle it
    console.log('📤 Submitting follow toggle form')
    
    // Optional: Close any open dropdowns after submission
    setTimeout(() => {
      const dropdowns = document.querySelectorAll('[data-dropdown-target="menu"]')
      dropdowns.forEach(dropdown => {
        if (!dropdown.classList.contains('hidden')) {
          dropdown.classList.add('hidden')
        }
      })
    }, 100)
  }
}